// extracted by css-extract-rspack-plugin
export default {"react-loading-skeleton--flex":"react-loading-skeleton--flex-oO1cap","reactLoadingSkeletonFlex":"react-loading-skeleton--flex-oO1cap"};